<template>
  <div class="indexSlot">
    <div class="top">
      <div style="width:92%">
        <img :src="goodType.pic?goodType.pic:'../../../../static/ico.png'" alt="" class="img1" width="20px" />
      <span class="fontName">{{goodType.cateName}}</span>
      </div>
      <div class="moreGood" @click="clickType(0)">了解更多>>></div>
    </div>
    <div class="centerNew1" >
      <div class="oneGood4">
        <img src="../../../../../static/index/good4.jpg" alt="" height="160px" width="100%">
        <div class="typeTu" >
         <div class="typesw" v-for="(item,index) in typeList.slice(0, 6)"
                    :key="index"
                    @click="clickType(0,index)">
                    <div class="fang"></div>
          <div class="itemT">{{item.cateName}}</div>
         </div>

        </div>


      </div>
      <div class="goodItem1"  v-for="(item,index) in goodList"
                    :key="index"
                    >

<img :src="item.image" alt="" class="goodImg" @click="clickGood(item.id,0)">
      <div class="goodName">{{item.storeName}}</div>
      <div class="goodCar">
        <div style="color:red" v-if="item.price" @click="toLogin()">¥{{item.price}}/<span class="fs16  ">  {{item.unitName}}</span></div>
      <div style="color:red" v-else>待询价</div>     <div  @click="clickGood(item.id,0)" class="carImg"></div>
      </div>
</div>
    </div>

  </div>

</template>

<script>
import {
  getProducts
} from '@/api/indexpage.js'
import store from '@/store'
import { getToken } from '@/axios/cookies.js'
import { getCates } from '@/api/noticedetail.js'
export default {
  props: { obj: Object },
  data () {
    return {
      goodType: [],
      goodList:[],
      typeList:[],
      listquery: {
        'isIntegral': 0, // 是否积分兑换商品 0否  1是
        'keyword': '', // 关键
        'news': 0, // 是否新品  0否  1是
        'priceOrder': '', // 价格排序
        'salesOrder': '', // 销量排序
        'sid': '', // 分类ID
        'type': '', // 类别 不传
        'limit': 4,
        'page': 1
      }
    }
  },
  created () {
    this.getTypeList()

  },
  methods: {
    toLogin(){
      const token = getToken()
      if ( !token ) {
        this.$router.push("/myLogin");
        //store.commit('setLoginVisible', true)
      }

    },
    // 新品查询
    async getProList () {
      const token = getToken()
    if(token===undefined){
      var res = await getProducts(this.listquery)
      if (res.status === 200) {
        this.goodList = res.data
        this.goodList.forEach((item, index) => {
        item.price = '登录查看';
     });
      }
    }else{
      var res = await getProducts(this.listquery)
      if (res.status === 200) {
        this.goodList = res.data
      }
    }

    },
    // 商品分类
    async getTypeList () {
      var res = await getCates()
      this.goodType = res.data[0]
      this.listquery.sid = res.data[0].id
      this.typeList = res.data[0].children
      this.getProList()
    },

    clickType (a, b) {
      this.$router.push({
                path: '/indexpage/productlist',
                query: {
                  a:a,
                b: b,

                }
            })
    },
    clickGood (id, type) {
      this.$router.push({
                path: '/productDetail',
                query: {
                productId: id,
                type: type
                }
            })
    }
  }
}
</script>

<style lang="scss">
.indexSlot {
  width: 1480px;
    margin:50px auto ;
   .top{
    height: 60px;
    line-height: 70px;
    border-bottom: 2px solid #586ad8;
    font-size: 18px;
      font-weight: 500;
      color: #586ad8;
      display: flex;
      .img1{
        vertical-align: middle;
        margin-left:10px
      }
      .fontName{
        margin-left:10px;
        vertical-align: middle;
      }
   .moreGood{
   // width: 100px;
    font-size: 15px;
    color: #626060;

   }
   }


}
 .centerNew1{
    //background: ora#nge;
    display: flex;
    flex-wrap:wrap;
  justify-content:space-between;
  margin-top:20px;
  .oneGood4{
    width: 20%;
    background: #586ad8;
  }
    .goodItem1{
      width:18%;
      font-size: 18px;
  text-align: center;
      background: #fff;
      .goodImg{
        width: 173px;
        height: 173px;
        margin-top: 40px;
        cursor: pointer;
      }
      .goodImg:hover{
        transform: scale(1.02);
}
      .goodName{
margin: 20px;
overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: pointer;
      }
      .goodName:hover{
        color: #409EFF;
      }
      .goodCar{
        width: 65%;
        margin: 30px auto ;
        display: flex ;
        justify-content: space-around;
    align-content: center;
    align-items: center;
    cursor: pointer;
    .carImg{
      width: 30px;
      height: 30px;
      background: url('../../../../../static/index/itemCar.png') no-repeat;
    }
    .carImg:hover{
        background: url('../../../../../static/index/itemCar2.png') no-repeat;
      }
      }

    }
   }
   .typeTu{
    display: flex;
    flex-wrap:wrap;
  justify-content:space-between;
    font-size: 14px;
    color: #fff;
    margin-top:10px

   }
   .typesw{
    width: 50%;


   }
   .itemT{
      overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: pointer;
    margin: 10px 10px;

    }
    .fang{
    width: 10px;
    height:10px;
    background: #fff;
    margin: 10px 10px;
    float: left;
    -webkit-transform: rotate(45deg);
     -moz-transform: rotate(45deg);
     -o-transform: rotate(45deg);
     -ms-transform: rotate(45deg);
     transform: rotate(45deg);
   }
</style>



// WEBPACK FOOTER //
// src/views/PageIndex/indexAll/components/goods.vue